<template>
  <v-card class="pa-5">
    <v-btn fab small flat absolute class="close-btn" @click="$emit('close')">x</v-btn>
    <v-flex xs12 v-if="validationInfo.errors" py-2> 
      <v-alert :value="true" type="error" v-for="(err, index) in validationInfo.errors" :key="index">{{err}}</v-alert>
    </v-flex><v-flex xs12 v-if="validationInfo.warnings" py-2> 
      <v-alert :value="true" type="warning" v-for="(warning, index) in validationInfo.warnings" :key="index">{{warning}}</v-alert>
    </v-flex><v-flex xs12 v-if="validationInfo.infos" py-2> 
      <v-alert :value="true" type="success" v-for="(info, index) in validationInfo.infos" :key="index">{{info}}</v-alert>
    </v-flex>
  </v-card>
</template>

<script>
  export default {
    props: ['companyId'],
    data: () => ({
      validationInfo: '',
    }),
    created() {
      this.$http.post(`company/validate/${this.companyId}`, {})
        .then((res) => {
          if(res.body.status === 'Success') {
            this.validationInfo = res.body.details;
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        });
    },
  };
</script>

<style lang="scss" scoped>
  .close-btn {
    right: 8px;
    top: 8px;
  }
  .card {
    height: auto;
    max-height: 90%;
    overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// Validate.vue?11ee14b9